// removed by extract-text-webpack-plugin
module.exports = {"wrapper-magazine-cover":"magazines_17_lb","wrapper-magazine-cover__content":"magazines_3lDaN","wrapper-magazine-cover__content-blank":"magazines_nTavg"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/components/MagazineCover/styles.scss
// module id = 1032
// module chunks = 1